import React from 'react';

const mainStyles = {
  animatedBar: {
    backgroundColor: 'rgba(222, 222, 222, 0.51)'
  }
};

const styles = {
  assignmentCard: {
    width: '100%',
    maxWidth: '900px',
    boxShadow: 'none',
    backgroundColor: '#ddd'
  },
  cardContent: {
    border: 'none'
  },
  animatedBar1: {
    height: '19px',
    marginBottom: '25px',
    width: '45%',
    backgroundColor: mainStyles.animatedBar.backgroundColor
  },
  animatedBar2: {
    height: '19px',
    marginBottom: '40px',
    width: '35%',
    backgroundColor: mainStyles.animatedBar.backgroundColor
  },
  animatedBar3: {
    height: '16px',
    width: '85%',
    backgroundColor: mainStyles.animatedBar.backgroundColor
  }
};

const AssignmentsCardPlaceholder = () => (
  <div className="assignment-card" style={styles.assignmentCard}>
    <div className="assignment-info" style={styles.cardContent}>
      <div className="animated-background" style={{ height: '19px', marginBottom: '25px', width: '45%' }} />
      <div className="animated-background" style={{ height: '19px', marginBottom: '40px', width: '35%' }} />
      <div className="animated-background" style={{ height: '16px', width: '85%' }} />
    </div>
  </div>
);

export default AssignmentsCardPlaceholder;
